import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";


const useServersData = (doFetch = false) => {
    const dispatch = useDispatch();
    const serversData = useSelector(state => state.serversData);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!doFetch || loading || serversData) return;

        setLoading(true);
        setError(null);

        dispatch.serversData.fetchServersData()
            .then(() => {
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                setError(err);
            });
    }, [doFetch, dispatch, loading, serversData]);

    return {serversData, loading, error}
};

export default useServersData;